import React, { useState, Fragment } from 'react'
import { useParams } from 'react-router'
import isEmpty from 'lodash/isEmpty'

import GeneralInput from '../../components/GeneralInput'
import BaseNavbar from '../../components/BaseNavbar'
import BaseFooter from '../../components/BaseFooter'
import StoreButtons from '../../components/StoreButtons'
import { updatePassword } from '../../services/account-management'

import './style.scss'

function PasswordReset() {
  const { token } = useParams()
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [email, setEmail] = useState('')
  const [newPassword, setNewPassword] = useState('')

  const submitPassword = () => {
    if (isEmpty(email) && isEmpty(newPassword)) {
      setError('Por favor, preencha os campos de Email e Nova Senha')
      return
    }

    updatePassword(token, { email, new_password: newPassword }).then((response) => {
      if (response.status === 200) {
        setSuccess('Senha alterada com sucesso!')
      } else {
        setError(
          `Erro na atualização de senha -  Status: ${response.status}, error: ${response.data.message}`,
        )
      }
    })
  }

  return (
    <Fragment>
      <BaseNavbar headerText='Recuperação de Senha' />

      <div className='recovery'>
        <div className='recovery_message'>
          {Boolean(success) ? (
            <span className='recovery_success'>{success}</span>
          ) : (
            <span className='recovery_error'>{error}</span>
          )}
        </div>

        {!!success ? (
          <StoreButtons />
        ) : (
          <div>
            <GeneralInput handleChange={(e) => setEmail(e.target.value)} label='Email' />

            <GeneralInput
              type='password'
              handleChange={(e) => setNewPassword(e.target.value)}
              label='Nova Senha'
            />

            <button className='recovery_button' onClick={submitPassword}>
              Confirmar
            </button>
          </div>
        )}
      </div>

      <BaseFooter />
    </Fragment>
  )
}

export default PasswordReset
